import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/styles";

import GridList from "@material-ui/core/GridList";

var fileGridStyles = function fileGridStyles(_ref) {
  var palette = _ref.palette;
  return {
    container: {
      display: "flex",
      flexWrap: "wrap",
      overflow: "hidden",
      width: "100%",
      background: palette.background.paper
    },
    gridList: {
      flex: 1
    }
  };
};

function FileGrid(props) {
  var classes = props.classes,
      files = props.files,
      render = props.render;


  return React.createElement(
    "div",
    { className: classes.container },
    React.createElement(
      GridList,
      { className: classes.gridList, spacing: 5 },
      files.map(render)
    )
  );
}

FileGrid.defaultProps = {
  files: []
};

FileGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  files: PropTypes.array,
  render: PropTypes.func
} : {};

export default withStyles(fileGridStyles)(FileGrid);